(function () {
  'use strict';

  angular
  .module('filter.phone', [])

  .filter('phoneNumber', function () {
    return function (num) {
      return _.replace(num, /\./g, ' ');
    };
  });

})();
